import { KeyAction } from '@/model/KeyAction'

export function keyActionService (event: any, actions: KeyAction[]): KeyAction | null {
  let action: KeyAction | null = null

  if(event.ctrlKey) {
    const foundAction: KeyAction | undefined = actions.find((item: KeyAction) => item.kind.includes('ctrl') && item.kind.split('+')[1] === event.key)
    action = foundAction ? foundAction : null
  } else {
    const foundAction: KeyAction | undefined = actions.find((item: KeyAction) => item.kind === event.key)
    action = foundAction ? foundAction : null
  }
  if (action) {
    action.event = event
    return action.resolve() ? action : null
  } else {
    return null
  }
}